const { CATEGORIES } = require('./site');

const _categories = CATEGORIES.map(c => c.as.replace('/', ''));
// prettier-ignore
module.exports = {
  ABOUT_REGEX: /\/about(?:\/|$)/,
  ACCOUNT_REGEX: /^\/account\//,
  ARCHIVE_REGEX: /\/archive(?:\/|$)/,
  AUTH_REGEX: /^\/(auth|sign-in|logout)(?:\/|$)/,
  AUTHOR_REGEX: /^\/authors\/(.*[^/])/,
  CATEGORY_REGEX: new RegExp(`^\/(${_categories.join('|')})$`),
  COLLECTION_REGEX: new RegExp(`^\/(?:collection|${_categories.join('|')})\/(.*[^/])`),
  CONTESTS_REGEX: /^\/contests\//,
  FAQ_REGEX: /^\/faq\//,
  FEATURES_REGEX: /^\/features\//,
  HOMEMADE_REGEX: /^\/homemade\//,
  IMAGE_COLLECTION_REGEX: /^\/image\/collection/,
  INSTAGRAM_REGEX: /^(?:[a-z]+:)?\/\/(.*)instagram\.com/,
  POST_REGEX: /^\/[^/?#]*-(\d+)(?:[?#].*)?$/,
  PRISM_REGEX: /^\/image\//,
  SEARCH_REGEX: /^\/search(?:\/|$)/,
  SHARED_REGEX: /^\/shared\//,
  SMALL_COOL_EXPERIENCE_REGEX: /^\/small-cool-experience\//,
  SUBMISSIONS_REGEX: /^\/submissions\//,
  // Old video page routes - these 301 to the JW hub, however the regex is still
  // necessary since we want to show a custom icon on teasers
  VIDEO_ID_REGEX: /^[^?#]*video:(\w{8})(?:[?#].*)?$/,
  VIDEO_URL_REGEX: /^https?:\/\/video\.apartmenttherapy\.com\/((m|p)\/.+)?$/,
  YOUTUBE_REGEX: /^(?:[a-z]+:)?\/\/(.*)youtube\.com/
};
